import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {TargetGroupsDetailsRepository} from '../repositories/target-groups-details.repository';

import {UserRole} from 'classes/user-role';
import {Category} from 'shared/models/target-groups/category';
import {Company} from 'shared/models/target-groups/company';
import {Group} from 'shared/models/target-groups/group';
import {ManagementLevel} from 'shared/models/target-groups/management-level';
import {TargetGroup} from 'shared/models/target-groups/target-group';
import { Question } from 'shared/models/questions/question';

@Injectable()
export class TargetGroupsDetailsService {

  constructor(private targetGroupsDetailsRepository: TargetGroupsDetailsRepository) { }

  public getTargetGroup(id: String): Observable<TargetGroup> {
    return this.targetGroupsDetailsRepository.getTargetGroup(id);
  }

  public createTargetGroup(targetGroup: TargetGroup): Observable<TargetGroup> {
    return this.targetGroupsDetailsRepository.createTargetGroup(targetGroup);
  }

  public updateTargetGroup(targetGroup: TargetGroup): Observable<TargetGroup> {
    return this.targetGroupsDetailsRepository.updateTargetGroup(targetGroup);
  }

  public deleteTargetGroup(targetGroup: TargetGroup): Observable<boolean> {
    return this.targetGroupsDetailsRepository.deleteTargetGroup(targetGroup._id);
  }

  public getAllRoles(): Observable<Array<UserRole>> {
    return this.targetGroupsDetailsRepository.getAllRoles();
  }

  public getAllCategories(): Observable<Array<Category>> {
    return this.targetGroupsDetailsRepository.getAllCategories();
  }

  public getAllCompanies(): Observable<Array<Company>> {
    return this.targetGroupsDetailsRepository.getAllCompanies();
  }

  public getAllManagementLevel(): Observable<Array<ManagementLevel>> {
    return this.targetGroupsDetailsRepository.getAllManagementLevel();
  }

  public getAllGroups(): Observable<Array<Group>> {
    return this.targetGroupsDetailsRepository.getAllGroups();
  }

  public getAllFirstOrderTips(): Observable<Question> {
    return this.targetGroupsDetailsRepository.getAllFirstOrderTips();
  }

  public getAllTargetGroups(): Observable<Array<TargetGroup>> {
    return this.targetGroupsDetailsRepository.getAllTargetGroups();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-details/services/target-groups-details.service.ts